/* eslint-disable react/jsx-boolean-value */
import { Alert, Checkbox, Form, InputNumber, Radio, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useWatch } from 'antd/es/form/Form'
import { now } from '../../../config/dayjsConfig'
import { DatePicker } from '../../../components/Form'
import { InitiatorType } from '../types'

const { Option } = Select

interface InitiatorFieldsProps {
  options: readonly InitiatorType[]
}

const InitiatorFields: React.FC<InitiatorFieldsProps> = ({ options }) => {
  const { t } = useTranslation()
  const form = Form.useFormInstance()
  const initiatorType = useWatch(['initiator', 'type'], form) ?? options[0]

  return (
    <>
      <Form.Item name={['initiator', 'type']} label={t('subscriptionsPage:initiator')} initialValue={options[0]}>
        <Radio.Group>
          {options.map(option => (
            <Radio style={{ margin: 4 }} key={option} value={option}>
              {t(`subscriptionsPage:${option}`)}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>

      {initiatorType === 'monthly' && (
        <Form.Item
          label={t('subscriptionsPage:iMonthly', { day: 'X' })}
          name={['initiator', 'monthly', 'day']}
          rules={[{ required: true, message: t('global:required-field') }]}
        >
          <InputNumber placeholder="15" min={1} max={31} precision={0} />
        </Form.Item>
      )}
      {initiatorType === 'weekly' && (
        <Form.Item
          name={['initiator', 'weekly', 'dow']}
          rules={[{ required: true, message: t('global:required-field') }]}
          label={t('subscriptionsPage:selectDayOfWeek')}
        >
          <Select style={{ width: 200 }}>
            {[1, 2, 3, 4, 5, 6, 0].map(val => (
              <Option className="type" key={val} value={val}>
                {now().day(val).format('dddd')}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}
      {initiatorType === 'daily' && (
        <Form.Item
          initialValue={true}
          valuePropName="checked"
          style={{ display: 'none' }}
          name={['initiator', 'daily']}
        >
          <Checkbox />
        </Form.Item>
      )}
      {initiatorType === 'periodLock' && (
        <>
          <Form.Item
            initialValue={true}
            valuePropName="checked"
            style={{ display: 'none' }}
            name={['initiator', 'periodLock']}
          >
            <Checkbox />
          </Form.Item>
          <Form.Item>
            <Alert message={t('global:attention')} description={t('subscriptionsPage:period-lock-info')} type="info" />
          </Form.Item>
        </>
      )}
      {initiatorType === 'manual' && (
        <>
          <Form.Item
            initialValue={true}
            valuePropName="checked"
            style={{ display: 'none' }}
            name={['initiator', 'manual']}
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            name={['params', 'endDate']}
            rules={[{ required: true, message: t('global:required-field') }]}
            label={t('subscriptionsPage:choose-which-months-scorecard-you-want-to-send')}
          >
            <DatePicker picker="month" placeholder="Select month" format="M/YYYY" />
          </Form.Item>
        </>
      )}
    </>
  )
}

export default InitiatorFields
